<template>
	<div class="footer-store-info">
		<div v-if="!!store">
			<div class="footer-store-body mb">
				<div class="footer-store-info__your-store">Your Store</div>
				<div class="store-details">
					<h3 class="footer-store-info__store-name">{{ store.city }}, {{ store.state }}</h3>
					<strong v-if="store.comingSoon" class="green fs-14">
						Be on the lookout...this store is coming soon!
					</strong>
					<base-button
						v-if="store.hoursStatus"
						class="hours-status fs-12 flex-row mb"
						@click="toggleStoreHours"
						:aria-expanded="showStoreHours.toString()"
					>
						<visually-hidden>Current store status:</visually-hidden>
						{{ store.hoursStatus }}
						<visually-hidden>. Press to {{ showStoreHours ? 'hide' : 'show' }} more information</visually-hidden>
						<icon class="fs-10 ml-sm" :name="`chevron-${toggleIcon}`" />
					</base-button>
					<transition-expand>
						<div v-if="showStoreHours" class="store-hours-wrapper">
							<div v-if="shortHours">
								<table>
									<tbody>
										<tr class="fs-12" v-for="(storeHours, day) in shortHours" :key="day">
											<td class="bold black">{{ day }}</td>
											<td class="text-right">{{ storeHours }}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<p v-if="displayText" :class="['store-message', storeDisplayStyle]">
								{{ displayText }}
							</p>
						</div>
					</transition-expand>
				</div>
				<div class="footer-divider"></div>
				<div class="footer-store-info__link-section">
					<a v-if="storePhoneLink" :href="storePhoneLink" class="footer-store-info__link">
						<icon name="phone" />
						{{ store.phone }}
					</a>
					<a v-if="storeDetailsUrl" :href="storeDetailsUrl" class="footer-store-info__link">
						<icon name="map-pin" />
						View Store Details
					</a>
				</div>
				<b-button
					color="blue"
					variant="secondary"
					minimal
					href="/store-finder/"
					class="footer-store-info__button"
				>
					Find Other Stores
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from 'Src/js/components/BaseButton.vue';
import BButton from 'JS/components/BButton.vue';
import Icon from 'Src/js/components/Icon.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import VisuallyHidden from 'Src/js/components/VisuallyHidden.vue';
export default {
	name: 'StoreSummary',
	components: {
		Icon,
		VisuallyHidden,
		BaseButton,
		BButton,
		TransitionExpand,
	},
	props: {
		store: {
			type: Object,
		}
	},
	computed: {
		displayText() {
			if (!this.store.currentHours) return;
			return this.store.currentHours.displayText;
		},
		isDesktop() {
			return !this.isTablet && !this.isMobile;
		},
		shortHours() {
			const daysArr = Object.keys(this.store.hours);
			const hoursArr = Object.values(this.store.hours);
			const obj = {};
			const shortDays = daysArr.map(d => d.includes('-')
				? d.split('-').map(el => el.slice(0,1)).join('–')
				: d.slice(0,3)
			);
			for (let i = 0;i < daysArr.length; i++) {
				obj[shortDays[i]] = hoursArr[i];
			}
			return obj;
		},
		storeDisplayStyle() {
			if (!this.store.currentHours) return;
			return this.store.currentHours.displayStyle || '';
		},
		storeDetailsUrl() {
			return this.store.urlAlias ? `/stores/${this.store.urlAlias}` : null;
		},
		storePhoneLink() {
			return this.store && this.store.phone ? `tel:+1${this.store.phone.replace(/\D/g, '')}` : null;
		},
		toggleIcon() {
			return this.showStoreHours ? 'up' : 'down';
		},
	},
	data() {
		return {
			showStoreHours: false,
		};
	},
	methods: {
		toggleStoreHours() {
			this.showStoreHours = !this.showStoreHours;
		}
	},
};
</script>

<style lang='less'>
@import '../../../less/_mixins.less';
.footer-store-info {
	max-width: 180px;
	width: 100%;

	table {
		max-width: 150px;
		width: 100%;
		color: #666;
	}

	td {
		padding: 3px 0;
	}

	.store-message {
		margin-bottom: 0;
	}

	&__your-store {
		font-size: 0.75rem;
		line-height: 1.25;
		color: #000000DE;
	}

	&__store-name {
		font-size: 1rem;
		line-height: 1.25;
		font-weight: bold;
		color: #000000DE;
		margin-bottom: 12px;
	}

	&__link-section {
		display: flex;
		flex-direction: column;
		gap: 8px;

	}

	&__link {
		text-decoration: none;
		color: #000000DE;
		font-size: 0.875rem;
		line-height: 1.25;

		.icon {
			font-size: 18px;
			line-height: 1;
		}
	}

	&__button {
		width: 100%;
		margin-top: 20px;
	}
}

.footer-store-body {
	border: solid 2px #E5E7F1;
	border-radius: 6px;
	padding: 10px;

	.footer-divider {
		margin: 12px 0;
	}

	.hours-status{
		font-weight: 500;
		color: #008040;
		cursor: pointer;
	}
}
</style>